import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { PrivateRoute } from "./PrivateRoute";
import { PublicRoute } from "./PublicRoute";
import moment from "moment";
import { loginAsync, selectUser, logOut } from "../app/user/userSlice";

export const AppRouter = () => {
  // const user = useSelector(selectUser);

  const getEmail = JSON.parse(localStorage.getItem("dbhuseread"));

  if (!getEmail) {
    localStorage.setItem("dbhuseread", JSON.stringify({ name: "Guest" }));
    window.location.replace("/login");
  }

  const { username: user } = getEmail;

  const dispatch = useDispatch();

  const checkLogin = useCallback(() => {
    let sessionTimeout = localStorage.getItem("dbhsessionTimeout");
    let dbhuseread = localStorage.getItem("dbhuseread");
    let login = localStorage.getItem("dbhloggedead");
    let sessionTimeoutMoment = moment(sessionTimeout, "DD/MM/YYYY, h:mm:ss a");
    let loadMoment = moment();

    if (
      dbhuseread !== undefined &&
      dbhuseread !== null &&
      sessionTimeout !== undefined &&
      sessionTimeout !== null
    ) {
      if (
        sessionTimeoutMoment > loadMoment &&
        !(login === "false" || login === false)
      ) {
        let credentials = JSON.parse(dbhuseread);

        dispatch(loginAsync(credentials.username));
      } else {
        dispatch(logOut());
      }
    } else {
      dispatch(logOut());
    }
  }, [dispatch]);

  useEffect(() => {
    checkLogin();
  }, [checkLogin]);

  return (
    <>{user !== null && <>{user ? <PrivateRoute /> : <PublicRoute />}</>}</>
  );
};
